/**
 * Подписи шаблонов WhatsApp.
 *
 * Статус здесь — не украшение: отправлять можно только `approved`,
 * остальное означает, что сообщение не уйдёт. Поэтому у каждого
 * состояния свой тон, а не общий серый бейдж.
 */

import type {TemplateStatus} from '@services/templates';

type Tone = 'ok' | 'wait' | 'bad';

const STATUS: Record<TemplateStatus, {label: string; tone: Tone}> = {
  approved: {label: 'Одобрен', tone: 'ok'},
  pending: {label: 'На проверке', tone: 'wait'},
  rejected: {label: 'Отклонён', tone: 'bad'},
  paused: {label: 'Приостановлен', tone: 'bad'},
  disabled: {label: 'Отключён', tone: 'bad'},
};

export const statusLabel = (s: TemplateStatus): string => STATUS[s].label;

export const statusClass = (s: TemplateStatus): string => {
  const tone = STATUS[s].tone;
  if (tone === 'ok') return 'bg-skr-paid/12 text-skr-paid';
  if (tone === 'wait') return 'bg-skr-warn/14 text-skr-warn';
  return 'bg-destructive/10 text-destructive';
};

/**
 * Подставляем подписи прямо в тело: «Здравствуйте, {{1}}» читается
 * хуже, чем «Здравствуйте, [Имя]». Именно так шаблон увидит клиника в
 * своём кабинете — здесь мы показываем ровно тот же текст.
 */
export const previewWithLabels = (body: string, labels: string[]): string =>
  body.replace(/\{\{(\d+)\}\}/g, (full, n: string) => {
    const label = labels[Number(n) - 1]?.trim();
    return label ? `[${label}]` : full;
  });
